export function normalizeNonEmptyString(value: unknown): string | undefined {
    if (typeof value !== "string") {
        return undefined;
    }

    const normalized = value.trim();

    return normalized.length > 0 ? normalized : undefined;
}

export function isString(value: unknown): value is string {
    return typeof value === "string";
}

export function normalizeSearchText(value: unknown): string {
    return String(value ?? "").toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
}

export function matchesSearchText(input: unknown, value: unknown): boolean {
    return normalizeSearchText(value).includes(normalizeSearchText(input));
}
